export const italianLocal = {
    "translation": {
        "LOAD_USER_INFO": "Convalida dei dati",
        "ACCESS_DIR": "Accessi recenti",
        "RES_INFO": "Informazioni. ",
        "AUDIT_INFO": "stato di controllo",
        "AUDIT_DOCS": "Revisione documentale",
        "AUDIT_INFO_SHORT": "Informazioni sulla revisione",
        "AUDIT_INFO_LONG": "Informazioni di controllo",
        "CONT": "Contraente",
        "APPROVEDS": "Approvato",
        "APPROVED": "Approvato",
        "REJECTED": "Rifiutato",
        "REJECTEDS": "Respinto",
        "PDG_EVAL": "In valutazione",
        "AUDIT_DOC": "Revisione documentale",
        "DOC": "Documento",
        "DOCS_CONT": "Documenti dell'appaltatore",
        "DOCS_EMPS": "Documenti dipendenti",
        "DOCS_VEHS": "Documenti del veicolo",
        "DOCS": "Documenti",
        "SBT_QUOT": "Invia quote",
        "SBT_WHIT_PP": "Presentazione parziale",
        "SBT_WHIT_PP_CRITERION": "Il calcolo delle presentazioni parziali considera il numero massimo di piani di pagamento attivi configurati",
        "DATE": "Data",
        "STATE_DOCTION": "Stato del documento",
        "STATE_RESS": "Stato della risorsa",
        "STATE_RES_ENTRY": "Stato della risorsa per il reddito",
        "DOC_DUE_BY_CRITERION": "Documentazione dovuta da criteri",
        "DOCTION": "Documentazione",
        "DOC_REQ": "Documentazione richiesta",
        "EMP": "Dipendente",
        "EMPS": "Dipendenti",
        "VEH": "Veicolo",
        "VEHS": "Veicoli",
        "CONTRACT": "Contrarre",
        "CONTRACTS": "contratti",
        "CONTRACTS_MENU": "Contratti",
        "RPT_SUB_HIS": "Storia dell'invio",
        "RPT_SUB_STS": "stato di sottomissione",
        "DOC_SUB": "Invio documenti",
        "MCONT": "Appaltatori",
        "MCONT_RES_STS": "Stato della risorsa",
        "SCONT_SUB_STS": "stato di sottomissione",
        "FILTERS": "filtri",
        "SCH_FILT": "Filtro",
        "FILT_FOR": "Filtra per",
        "REQ_DOC": "Documento richiesto",
        "SEARCH_FILTER": "cerca qualche filtro...",
        "REG_NUM": "Numero di record",
        "COPY": "copia",
        "COPIED": "Copiato",
        "DOWNLOAD_PAGE": "Scarica la pagina",
        "DOWNLOAD_ALL": "Scarica tutto",
        "DOWNLOAD": "Scarico",
        "CRITERION": "Criterio",
        "CRITERION_DESCRIP": "Dettaglio criterio",
        "DOC_COD": "Codice documento",
        "DOC_NAME": "Nome dottore",
        "DOC_PROX_EXRE": "Doc Prox. ",
        "SEARCH_VEH": "Cerca Veicolo",
        "SEARCH_EMP": "Cerca dipendente",
        "SEARCH": "Cercare",
        "INFO_RES": "Informazioni sulle risorse",
        "AUDIT_RESS": "Controllo delle risorse",
        "RES": "Risorsa",
        "RESS": "Risorse",
        "TPE_RES": "Tipo di risorsa",
        "ID": "ID",
        "PATENT": "Brevetto",
        "ID_PATENT": "documento d'identità/brevetto",
        "NAME": "Nome",
        "BND_MOD": "Fare il modello",
        "NAME_BND_MOD": "Nome/Marca/Modello",
        "STION_RES": "Stato della risorsa",
        "STION": "Situazione",
        "STE_CURR_DATE": "Stato fino ad oggi",
        "STE_APTDE": "Attitudine",
        "EXRE": "Scadenza",
        "PNT_DOC": "Invia doc",
        "STATE": "Stato",
        "CONTRACTS_STATUS": "stato del contratto",
        "EMP_PHOLDER_ENTRY": "Cerca per ID o nome",
        "VEH_PHOLDER_ENTRY": "Cerca per brevetto o nome",
        "APT_ENTRY": "Adatto",
        "UN_APT_ENTRY": "Inadatto",
        "STFING": "Soddisfacente",
        "UN_STFING": "Non soddisfacente",
        "CUIL": "Cuil",
        "RBO": "Intestazione",
        "RANK": "Classificazioni",
        "ACTIVE": "Risorsa",
        "INACTIVE": "Oziare",
        "LOW": "Basso",
        "LASTS": "Scorso",
        "DAYS": "Giorni",
        "OPENING": "Apertura",
        "ENTRY": "Reddito",
        "CHANGE": "Modifica",
        "APT": "Adatto",
        "PART_APT": "Vestibilità parziale",
        "UN_APT": "Inadatto",
        "PENDING_CLOSE": "Chiusura orecchini",
        "VALTY": "Validità dell'autorizzazione",
        "VALIDITY": "Validità dell'autorizzazione",
        "EXIT": "Esci",
        "SUBMITED": "Presentata",
        "PDING": "Orecchino",
        "PDING_OP": "In sospeso (in ritardo e non presentato)",
        "NOT_SUBMITED": "Nessuno spettacolo",
        "EXPIRED": "Sconfitto",
        "CREDENTIAL": "Credenziali",
        "APPLY": "Fare domanda a",
        "SHOW_MORE": "Mostra di più",
        "NO_DATA": "Non ci sono dati da mostrare",
        "YES": "Sì",
        "NO": "NO",
        "DEPNDS_REL": "Grado di dipendenza",
        "SUB_CONTRACT": "esternalizzato",
        "CONCEPT": "Concetto",
        "OTHER": "Altro",
        "UP_DATE": "Data di dimissione",
        "TYPE_CONTRACT": "tipo di contratto",
        "IS_DRIVER": "è conducente",
        "CODE": "Codice",
        "DESCRIPTION": "Descrizione",
        "CONCEPT_DESCRIP": "Descrizione del concetto",
        "DATE_SINCE": "Data da",
        "DATE_UNTIL": "Data a",
        "DATE_PRESENT": "Data di presentazione",
        "DATE_AUDIT": "Data di revisione",
        "CORRESPONDING_TO": "Corrisponde a ",
        "EVENTUALITY": "Eventualità",
        "VALUE": "Di valore",
        "MORE_INFO": "Maggiori informazioni",
        "EXCEPTION_UNTIL": "Puoi inserire fino a ",
        "STATUS_TO_ENTRY": "stato della risorsa",
        "SEND_TO": "Invia tutto",
        "SEND": "Inviare",
        "LAST_ONE_DAYS": "Ultime 24 ore",
        "LAST_SEVEN_DAYS": "Ultimi 7 giorni",
        "LAST_SEVENTEEN_DAYS": "Ultimi 15 giorni",
        "LAST_THRITY_DAYS": "Ultimi 30 giorni",
        "SELECT": "Scegliere",
        "HELLO": "Ciao!",
        "FILTER_DOCS": "Filtri documento",
        "FILTER_RES": "Filtri risorse",
        "NO_DATA_SEARCH": "Non ci sono risultati di ricerca.",
        "SHOW_ALL": "Mostra tutto",
        "ERROR_PAGE_TITTLE": "Errore, pagina non trovata",
        "ERROR_TENANT_TITTLE": "Errore, l'istanza non è configurata",
        "ERROR_PAGE_MESSAGE": "Spiacenti, non è stato possibile trovare la pagina richiesta. ",
        "ERROR_TENANT_MESSAGE": "Si prega di contattare Exactian.",
        "ERROR_PAGE_GO_TO": "Torna in cima",
        "ERROR_TENANT_GO_TO": "Vai a Esattiano",
        "NO_DOCUMENTS_LEFT": "Nessuna documentazione dovuta",
        "NO_DATA_PERIOD_LEFT": "Non ci sono informazioni nel periodo selezionato",
        "ERASE": "Eliminare",
        "FIRSTWORD_MSG_LOAD_DOCS_STATUS": "Premere",
        "FIRST_KEY_WORD_LOAD_DOCS_STATUS": "Carica informazioni",
        "SECONDWORD_MSG_LOAD_DOCS_STATUS": "Per visualizzare questo grafico o",
        "SECOND_KEY_WORD_LOAD_DOCS_STATUS": "Dettaglio generale",
        "THIRDWORD_MSG_LOAD_DOC_STATUS": "Per vedere maggiori informazioni.",
        "MSG_NOT_TO_GO": "* Quando inizia il caricamento, non devi uscire dalla schermata.",
        "PAST_DUE_HISTORY": "Documentazione del debito",
        "ALL_APTITUDES": "Tutte le situazioni",
        "ALL_AUDITS": "Tutti gli stati",
        "ALL_CONTRACTS": "Tutti i contratti",
        "ALL_CRITERION": "Tutti i criteri",
        "ALL_DOCS": "Tutti i documenti",
        "ALL_EMP": "Tutti i dipendenti",
        "ALL_VEH": "Tutti i veicoli",
        "ALL_OPENINGS": "tutte le aperture",
        "ALL_EVENTIUALITIES": "tutte le eventualità",
        "ALL_RESOURCES": "tutte le risorse",
        "ALL_CLASSIFICATION": "Tutte le classificazioni",
        "HISTORY": "Documentazione",
        "FROM": "Da",
        "UNTIL": "Fino a",
        "PERIOD": "Periodo",
        "SUBMIT_DOC": "Presente documento",
        "AUDITOR": "Revisore dei conti",
        "SHOW_DETAIL": "Vedi dettaglio",
        "GLOBAL_PRESENTATION": "Presentazione generale",
        "INDVIDUAL_PRESENTATION": "Presentazione solista",
        "ATTACH": "Allegare",
        "DELETE": "Eliminare",
        "SHOW_FILE": "Vedi il file",
        "CANCEL": "Annulla",
        "DATE_RANGE": "Intervallo di date",
        "SITUATION_HISTORY": "Situazione storica",
        "ACCEPT": "Accettare",
        "LOAD_FILE": "File caricato",
        "SELECT_TWO": "Scegliere",
        "OR_DRAG": "o trascina un documento",
        "ACCEPT_FORMATS": "Formati supportati",
        "MAX_SIZE": "Taglia massima",
        "MAX_SIZE_ERROR": "File maggiore di",
        "ACCEPT_FORMATS_ERROR": "Formato file non accettato",
        "IN_EVALUATION_FROM": "In valutazione da allora",
        "SELECT_TYPERES_O_DOC": "Devi contrassegnare Tipo di risorsa o Documento",
        "NO_INSTRUCTIONS": "Nessuna istruzione",
        "SERVER_ERROR": "Errore del server",
        "REPEAT_SUBMIT_ERROR": "Esiste già un invio per il documento/risorsa/periodo",
        "ERROR_SUBMIT_TITTLE": "Errore di caricamento del documento",
        "ERROR_SUBMIT_SERVER": "Si è verificato un problema durante il caricamento del documento",
        "SUCCESS_SUBMIT_TITTLE": "Pronto!",
        "SUCCESS_SUBMIT_MESSAGE": "Il documento è stato inviato correttamente. ",
        "WARNING": "Avvertimento",
        "REPLACE_WARNING": "Esiste già un documento che corrisponde a tali date. ",
        "PRESET_DATE_INFO": "Data impostata automaticamente, può essere modificata",
        "DELETE_NEXT_DOC": "Stai per eliminare il seguente documento:",
        "SURE_TO_CONTINUE": "Sei sicuro di continuare?",
        "NO_DOC_DUE": "Nessuna documentazione dovuta",
        "DOC_DUE_NUM_PART_ONE": "Documentazione dovuta, in ultimo",
        "DOC_DUE_NUM_PART_TWO": "mesi. ",
        "GLOBAL_DOC_UPLOAD": "Caricamento globale dei documenti",
        "UPLOAD_FILE": "Caricare un file",
        "CONTINUE": "Continua",
        "CONFIRM": "Confermare",
        "REPLACE_PRES_IF_HAS_DUP": "Sostituire la presentazione in caso di duplicazione.",
        "TITLE_GLOBAL_DOC_STEP1": "Seleziona il tipo di documento che desideri caricare a livello globale",
        "TITLE_GLOBAL_DOC_STEP2": "Seleziona tutte le risorse su cui vuoi caricare il documento scelto in precedenza.",
        "FILE_NOT_FOUND": "File non trovato.",
        "SELECT_ALL": "seleziona tutto",
        "TITLE_EXP_IMP_STEP2": "Scarica o carica il file con le risorse",
        "DOWNLOAD_FILE": "Download file",
        "ERROR": "Errore",
        "IMPORT_ERROR_RES_TXT": "Record/i che non corrispondono alla busta paga. ",
        "FILE_HAVE": "Il file contiene",
        "EXP_IMP_BTN_STEP2": "Esporta / Importa file",
        "UPLOAD_OTHER_FILE": "Carica un altro file",
        "WANT_HAVE_SAMPLE_FILE": "Vuoi avere il file di esempio?",
        "TEXT_EXP_IMP_STEP2": "Il file di esempio include tutte le risorse alle quali è possibile presentare il documento scelto in precedenza.",
        "SELECTED": "Selezionato/i",
        "NO_EXPIRATION": "Senza caducità",
        "RESOURCE_INFO": "Dettaglio risorsa",
        "EXPORT": "Esportare",
        "GENERAL_REPORT": "Rapporto generale",
        "CONTRACTOR": "Contraente",
        "IMPORT_ERROR_STRUCTURE_TXT": "Verifica che il tuo file contenga una colonna denominata",
        "NOT_EDIT_COL": "IMPORTANTE!: Non modificare il nome delle colonne.",
        "ERROR_IMP": "Errore di importazione",
        "ERROR_FORMAT": "Errore di formato",
        "PREVIEW": "Anteprima",
        "Total": "Totale",
        "DRIVE": "Lei guida",
        "BULK_UPLOAD_DETAIL": "Dettagli del caricamento collettivo ",
        "VALTY_WORD": "Validità",
        "DELETE_PRES": "Elimina presentazione",
        "DELETE_PRES_SUCCESS": "La presentazione è stata eliminata con successo!",
        "DELETE_PRES_ERROR": "Impossibile eliminare la presentazione",
        "DELETE_PRES_ERROR_MSG": "Si è verificato un problema durante l'eliminazione del file.",
        "OPEN_FILE_IN_NEW_TAB": "Il file è stato aperto in una nuova scheda del browser.",
        "TOTAL_PRESS": "Presentazione completa",
        "DOC_PERIOD": "Documentazione corrispondente a",
        "SUCCESS_SUBMIT_MESSAGE_TWO": "Il documento è stato inviato correttamente.",
        "VALIDITY_DATE": "Data effettiva",
        "VALIDITY_ERROR_MESSAGE": "La data di inizio deve essere maggiore della data di inizio.",
        "USER_NAME": "Utente",
        "PASSWORD": "Parola d'ordine",
        "HELLO_AGAIN": "Ciao di nuovo!",
        "RECOVER_PASSWORD": "Recupera la password",
        "GET_INTO": "Entrare dentro",
        "ENTER_USER_NAME": "Inserisci il tuo nome utente",
        "ENTER_PASSWORD": "Inserisci la tua password",
        "ERROR_LOGIN_CREDENTIALS": "Credenziali sbagliate!",
        "ENTER_MAIL": "Inserisci il tuo indirizzo email",
        "CHOOSE_OPENING": "Selezionane uno",
        "CHANGE_OPENING": "Cambia accesso",
        "CHANGE_BUILDING": "Cambia edificio",
        "ENTER_MAIL_AND_USER_TO_RESET": "Inserisci la tua email e il tuo nome utente per reimpostare la password",
        "WRONG_USER_ERROR": "Inserisci un'e-mail valida",
        "INSTANCE_INFO_ERROR": "Istanza non trovata",
        "CHECK_YOUR_MAIL": "Controlla la tua e-mail",
        "WE_SEND_A_MAIL_TO": "Ti abbiamo inviato una mail a",
        "FOR_RESET_PASSWORD": "così puoi reimpostare la password",
        "DID_NOT_ARRIVE_THE_MAIL": "Non hai ricevuto l'e-mail?",
        "REMEMBER_CHECK_SPAM": "Ricordati di controllare la cartella spam",
        "RESEND_MAIL": "Rinvia l'e-mail",
        "CHANGE_MAIL": "Cambia email",
        "WAS_SEND": "Inviato",
        "WELCOME": "Benvenuto",
        "NEW_PASSWORD": "nuova password",
        "MY_ACCOUNT": "Il mio conto",
        "REPORTS": "Rapporti",
        "CONFIG": "Impostazioni",
        "HELP": "Aiuto",
        "LOGGOUT": "cancella la sottoscrizione",
        "SCAN_OR_CODE_DNI": "Posiziona il cellulare davanti al codice QR o ID",
        "MANUAL_ENTRY": "Inserimento manuale",
        "WRITE_ID": "Scrivi il numero di identificazione o DNI.",
        "PASS_CREATED": "Password creata con successo",
        "ENABLED": "Abilitato",
        "NOT_ENABLED": "Non abilitato",
        "APT_TO_ENTRY": "Adatto per entrare",
        "NOT_APT_TO_ENTRY": "Non adatto per entrare",
        "STATUS_DETAIL": "Dettaglio stato",
        "SEARCH_CODE_OR_SCAN": "Cerca per ID | Numero documento o scansione QR",
        "MAX_EIGHT_CARACT_ALLOW": "Minimo 8 caratteri consentiti",
        "TO_USE_CAMERA_NEED_PERMISSIONS": "Per utilizzare lo scanner sono necessarie le autorizzazioni della fotocamera",
        "ALLOW_USE": "Consenti l'uso",
        "INSTANCE_NOT_CONFIG_TO_ENTRY": "Istanza non configurata per le entrate",
        "CREATE_PASS": "Crea una password",
        "WRITE_NEW_PASS": "Inserisci una nuova password per il tuo account",
        "CONFIRM_PASS": "Conferma password",
        "MIN_EIGHT_MAX_FIFTY_CARACT": "Minimo 8 caratteri e massimo 50 caratteri",
        "UPPERCASE": "Lettera maiuscola",
        "LOWERCASE": "Minuscolo",
        "NUMBER": "Numero",
        "EMAIL": "E-mail",
        "VALIDATING": "Convalida",
        "SELECT_CONTRACT": "Seleziona un appaltatore",
        "PERSON_ENTRY_WITH": "La persona entra con",
        "SELECT_VEH": "Seleziona veicolo",
        "ENTRY_DETAIL": "Dettaglio reddito",
        "WRITE_VISIT_DATA": "Inserisci i dettagli della visita",
        "SUCCESS_ACCESS_DESC": "L'inserimento è stato effettuato con successo",
        "VISIT": "Visita",
        "VISITS": "visite",
        "HOURS": "Ore",
        "RES_BY_OPENINGS": "Risorse per le aperture",
        "RES_BY_HOURS": "Risorse orarie",
        "ADDITIONAL_INFO": "Informazioni aggiuntive",
        "CLASSIFICATION": "Classificazione",
        "COLOR": "Colore",
        "ENGINE_NUMBER": "Numero del motore",
        "CHASSIS_NUMBER": "Numero di telaio",
        "ASSIGNED": "assegnato",
        "DATE_HOUR_EXIT": "Data e ora della dimissione",
        "DATE_HOUR_ENTRY": "Data e ora del ricovero",
        "HOUR": "Ora",
        "SAVE": "Mantenere",
        "EDIT": "Modificare",
        "DEPARTURE": "Scarico",
        "EXIT_DETAIL": "Dettaglio scarico",
        "PERSON_EXIT_WITH": "La persona se ne va con",
        "SUCCESS_EXIT_DESC": "Lo scarico è stato completato con successo",
        "TOKEN_ERROR": "Sessione terminata",
        "ACCESS_WITH_CAR": "La persona entra con il proprio mezzo o con quello dell'azienda.",
        "EXIT_WITH_CAR": "La persona parte con il proprio mezzo o con quello dell'azienda.",
        "NEXT": "Seguente",
        "GET_BACK": "Ritorno",
        "CONT_MAIN": "Appaltatore principale",
        "SCAN_QR_OR_ID": "Scansiona QR o ID",
        "NO_CAR": "senza veicolo",
        "NO_CAR_ACCESS": "La persona entra senza veicolo",
        "NO_CAR_EXIT": "La persona parte senza veicolo",
        "OBSERVATIONS": "Osservazioni",
        "DENY": "Negare",
        "SCAN_ERROR": "Codice scansionato non valido",
        "RES_BY": "Risorse per",
        "RES_OF": "Risorse di",
        "STATUS_ERROR_ACCESS": "Dipendente, il veicolo inserito non può essere inserito a causa dello stato",
        "STATUS_ERROR_ACCESS_VISIT": "La visita che stai tentando di inserire non può essere inserita a causa del suo stato",
        "CONCURRENCY_ERROR_ACCESS": "Il dipendente, veicolo che sta tentando di entrare è già entrato",
        "CONCURRENCY_ERROR_EXIT": "Il dipendente, veicolo che sta tentando di partire non è entrato",
        "CONCURRENCY_ERROR_ACCESS_VISIT": "La visita che stai tentando di inserire è già inserita",
        "CONCURRENCY_ERROR_EXIT_VISIT": "La visita che sta tentando di partire non è inserita",
        "PARAM_MISSMATCH": "La visita corrisponde ad un dipendente attivo o non idoneo in congedo",
        "VISIT_REASON": "Ragione per visitare",
        "EMPLOYEE_NO_ACCESS_ERROR": "Il dipendente non è autorizzato ad entrare",
        "FINISH": "Fine",
        "VEHICLE_DATA_NO_CONFIRM": "Ci sono informazioni su un veicolo non confermato.",
        "DO_YOU_WANT_TO_ADD": "Vuoi aggiungerlo?",
        "ADD": "Aggiungere",
        "VEHICLE_DATA_NO_COMPLETED": "Hai inserito informazioni incomplete per un nuovo veicolo.",
        "DO_YOU_WANT_TO_COMPLETE": "Vuoi completare le informazioni?",
        "COMPLETE": "Completare",
        "FULL_NAME": "Nome e cognome",
        "ENTER_FULL_NAME_OF_VISIT": "Inserisci il nome completo della visita",
        "ENTER_VISIT_REASON": "Inserisci il motivo della visita",
        "ENTITY_MAG_DESC": "Descrizione di questo tipo di rapporti",
        "PARAMS": "Parametri",
        "MANDATORY_INFO": "Informazione obbligatoria",
        "QR_CODE_SCANNER": "Scanner di codici QR/ID",
        "QR_CODE_ACTIVE_DESC": "Se è attivo, lo scanner può essere utilizzato.",
        "VISIT_ACTIVE_DESC": "Possono entrare come visitatori i dipendenti in aspettativa/inattivi con documentazione dovuta.",
        "PREFERENCES": "Preferenze",
        "OPENING_ACTIVE_DESC": "Se è attivo, è obbligatorio selezionare un'apertura una volta effettuato l'accesso.",
        "ENTITY_MANAGEMENT": "Gestione dell'ente",
        "OPENINGS": "Aperture",
        "ENABLE_OPENINGS": "Abilita le aperture nell'app.",
        "SEARCH_OPENNINGS": "Aperture di ricerca",
        "ENTRY_DEPARTURE": "Entrata / Partenza",
        "PERMANENCE": "Permanenza",
        "TODAY": "Oggi",
        "ALL": "Tutto",
        "TYPES": "Tipi",
        "PERMISSIONS_ERROR": "Non hai i permessi, parlane con l'Amministratore.",
        "UNDERSTOOD": "Inteso",
        "RESOURCES_IN_OPENING_ERROR": "L'apertura non può essere disabilitata poiché ha un reddito registrato.",
        "RESOURCES_IN_WITHOUT_OPENING_ERROR": "Errore, ci sono risorse inserite senza l'apertura.",
        "ENTITY_CONFIG": "Configurazione entità",
        "PARAMS_CONFIG": "Impostazione dei parametri",
        "DATA_BASICS_CONFIG": "Configurazione dei dati di base",
        "PREFERENCES_CONFIG": "Impostazioni delle preferenze",
        "NO_OPENING": "Nessuna apertura",
        "PERMANENCE_TIME": "Tempo di sosta",
        "WRITE_VISIT_VEHICLE_DATA": "Inserisci i dati del veicolo",
        "RES_NAME": "Nome risorsa",
        "TYPE": "Tipo",
        "CONTRACTOR_CUIT": "Taglio dell'appaltatore",
        "MOVEMENTS": "Movimenti",
        "TIME_ELAPSED": "Tempo trascorso",
        "BUILDING": "Edificio",
        "AREA": "La zona",
        "MINUTES": "Minuti",
        "PLANT_RESOURCES": "Risorse in pianta",
        "DOWNLOAD_REPORT": "Scarica rapporto",
        "EMP_DETAIL": "Dettaglio dipendente",
        "ENTER_VEHICLE_VISIT_PATENT": "Inserisci numero di brevetto",
        "ENTER_VEHICLE_VISIT_MODEL": "Inserisci modello",
        "ENTER_OBSERVATIONS": "Inserisci osservazioni",
        "REPORT": "rapporto",
        "VEH_DETAIL": "Dettaglio del veicolo",
        "VIS_DETAIL": "Dettaglio della visita",
        "DETAIL": "Dettaglio",
        "MOV_DETAIL": "Dettaglio dei movimenti",
        "MINUTE": "Minuto",
        "RES_PERMANENCE_DETAIL": "Dettaglio permanenza risorsa",
        "EMPLOYEE_NO_ACCESS_OPENING_ERROR": "La risorsa non appartiene all'apertura selezionata",
        "LINK_EXPIRED": "Collegamento scaduto",
        "EXCEPTED": "Escluso",
        "RES_ENTERED": "Risorse immesse",
        "PAGE": "Pagina",
        "OF": "Di",
        "NORMAL_HS": "Orari normali",
        "50%_HS": "Straordinario 50%",
        "100%_HS": "Straordinario 100%",
        "NORMAL_HS_SHORT": "Orario normale",
        "50%_HS_SHORT": "Ore extra 50%",
        "100%_HS_SHORT": "Ore extra 100%",
        "RESOURCE_DATA": "Dati risorsa",
        "USER_ACCESS": "Accesso utente",
        "USER_EXIT": "Uscita utente",
        "TOTAL_HS": "Ore totali",
        "TOTAL_HS_PER": "Totale ore per",
        "RECORDS": "Registri",
        "BY": "Di",
        "ERROR_TRY_AGAIN": "Si è verificato un errore, riprova.",
        "NOT_ENABLE_OPENING_WITHOUT_OPNING": "Non puoi abilitarlo poiché hai inserito risorse senza a ",
        "ASSIGNED2": "assegnata",
        "REQUESTS": "Query",
        "ERROR_DATA_ENTER": "Si è verificato un errore, controlla i dati inseriti",
        "DOWNLOAD_APP": "Installa scorciatoia",
        "EMPLOYEE_HAVE_FUTURE_INCOME_ERROR": "L'ID richiesto corrisponde a un dipendente la cui data di ingresso in Exactian è nel futuro",
        "AUTHORIZED_BY": "Approvato da",
        "CHOOSE_CAMERA": "Seleziona una fotocamera da scansionare",
        "NAME_OF_ENTITIES": "Nome delle entità",
        "CONF_NAME_OF_ENTITIES": "Impostazioni del nome dell'entità",
        "CREATE": "Creare",
        "ENTER_DESCRIPTION": "Inserisci una descrizione",
        "RESOURCES_IN_BUILDING_ERROR": `Non è possibile disabilitare chi ha i biglietti registrati.`,
        "CREATED_SUCCESSFULLY": "creato con successo",
        "EDITED_SUCCESSFULLY": "modificato con successo",
        "DELETED_SUCCESSFULLY": "rimosso con successo",
        "ARE_YOU_SURE_DELETE": "Sei sicuro di voler eliminare",
        "CHOOSE_BUILD": "Seleziona un",
        "NO_BUILDING": "Nessun edificio",
        "THE_RESOURCE_IS_ALREADY_IN": "La risorsa è già inserita",
        "NO_ASSIGNMENT": "Nessuna assegnazione",
        "CODE_ALREADY_EXIST": "Il codice esiste già, modifica il codice.",
        "RESOURCES_IN_BUILDING_ERROR_TO_DELETE": `Non può essere cancellato poiché ha registrato entrate.`,
        "NOT_ACCESS_OPENING": `non esiste o è disabilitato.`,
        "BUILDINGS_IN_OPENING": `L'azione non può essere eseguita perché assegnata`,
        "THERE_ARE": `Fieno`,
        "WITHOUT": `peccato`,
        "ASSOCIATED": `associati`,
        "CANT_DELETE_FOR_ENTRYS": `Non può essere cancellato poiché ha registrato entrate.`,
        "CANT_ENABLE_FOR_ENTRYS": `Non può essere disabilitato poiché ha registrato redditi.`,
        "CANT_DELETE_FOR_ASSIGNED_TO_USER": `Non può essere eliminato poiché l'entità è assegnata a un utente.`,
        "CANT_DELETE_BUILDING_HAS_AREAS_ERROR": `Non può essere cancellato poiché ha aree assegnate.`,
        "FREE_ACCESS_AREA": "Accesso gratuito",
        "ACCESS_ONLY_TO": "Accesso solo a",
        "SELECT_PERSON_TO_VISIT": "Seleziona la persona che visiti",
        "PERSON_VISITED": "Persona visitata",
        "SURNAME": "Cognome",
        "PERSON_TO_VISIT": "Persona un visitatore",
        "CONFIG_PERSON_TO_VISIT": "Configurazione delle persone da visitare",
        "SECTORS": "Settori",
        "CONFIG_SECTOR": "Configurazione dei settori",
        "SECTOR": "Settore",
        "AMOUNT_PEOPLE_ALLOWED": "Numero di persone ammesse",
        "ALLOW_PEOPLE_TO_VISIT": "Consentire alle persone di visitare come dati obbligatori",
        "NOT_EXIST_SECTOR_ERROR": "Il settore non esiste o è disabilitato",
        "NAME_ALREADY_EXIST": "Il nome esiste già, cambia il nome.",
        "DNI_ID_ALREADY_EXIST": "Il DNI/ID esiste già, modifica il DNI/ID.",
        "OPENING_HAS_BUILDINGS_ERROR_SELECTED": "Hai selezionato un'apertura che contiene edifici. Seleziona l'edificio.",
        "RESOURCE_IN_VISITED_ERROR": "La persona non può essere disabilitata perché viene visitata.",
        "PERSON_VISITED_ERROR": "La persona non può essere eliminata perché è già stata visitata.",
        "SECTOR_USED_ERROR": "Il settore non può essere disabilitato o eliminato perché è in uso.",
        "CANT_DELETE_BUILDING_HAS_PERSON_ERROR": `Non può essere eliminato poiché ha assegnato persone da visitare.`,
        "WITHOUT_SECTOR": `Sin sector`,
        "OPENING_WITH_PERSON_ASIGNED_ERROR": `Non può essere disabilitato perché ha una persona assegnata da visitare.`,
        "NOT_ACCESS_OPENING_START": "Non è stato possibile completare l'inserimento perché si è effettuato l'accesso senza",
        "NOT_ACCESS_OPENING_START_MID": "e ci sono",
        "NOT_ACCESS_OPENING_MID": "ingressi abilitati. Effettuare nuovamente l'accesso ad una voce specifica",
        "NOT_ACCESS_OPENING_END": "per poter effettuare entrate/uscite",
        "BUILDINGS_WITHOUT_OPENING_START": "Non è stato possibile completare l'inserimento perché hai effettuato il login senza",
        "BUILDINGS_WITHOUT_OPENING_START_MID": "e ci sono",
        "BUILDINGS_WITHOUT_OPENING_MID": "abilitati. Effettuare nuovamente l'accesso ad uno specifico",
        "BUILDINGS_WITHOUT_OPENING_END": "per poter effettuare entrate/uscite.",
        "NOT_ENABLE_BUILDING_WITHOUT_BUILDING": "Non puoi abilitarlo poiché hai risorse inserite senza a ",
        "MANDATORY_PEOPLE_TO_VISIT_ERROR": 'Configura almeno una "persona da visitare"',
        "MAXIMUM_PEOPLE_TO_VISIT_ERROR": "Il numero di persone selezionate supera la quota consentita",
        "EQUIPMENT_OR_TOOLS": "Attrezzatura o strumenti",
        "THE_PERSON_ACCESS_WITH_EQUIPMENT_OR_TOOLS": "La persona entra con attrezzature o strumenti.",
        "SELECT_WITH_EQUIPMENT_OR_TOOLS": "Seleziona attrezzatura o strumento",
        "EQUIPMENT_OR_TOOLS_SELECTABLE": "Attrezzatura/Strumenti",
        "ADD_INFO_OF_TOOL_OR_EQUIPMENT": "Inserisci informazioni aggiuntive come il codice o il modello dell'attrezzatura",
        "TYPE_EQUIPMENT_OR_TOOLS": "Tipo di attrezzatura o strumenti",
        "TYPE_EQUIPMENT_OR_TOOL_CREATE_SUCCESSFULLY": "Tipo di attrezzatura o strumento creato con successo",
        "TYPE_EQUIPMENT_OR_TOOL_EDIT_SUCCESSFULLY": "Tipo di attrezzatura o strumento modificato con successo",
        "TYPE_EQUIPMENT_OR_TOOL_DELETED_SUCCESSFULLY": "Tipo di attrezzatura o strumento eliminato con successo",
        "TYPE_EQUIPMENT_OR_TOOL_NAME_ALREADY_EXIST": "Il nome esiste già, per favore cambia il nome.",
        "TYPE_EQUIPMENT_OR_TOOL_NAME_CANNOT_DISABLED": "C'è una risorsa inserita senza uscita che è entrata con questo tipo di attrezzatura",
        "TYPE_EQUIPMENT_OR_TOOL_NAME_CANNOT_DELETE": "L'attrezzatura non può essere eliminata perché è già stata utilizzata",
        "CONFIG_EQUIPMENT_OR_TOOLS": "Configura attrezzatura o tipi di strumenti",
        "EQUIPMENT_DATA_NO_CONFIRM": "Ci sono informazioni su apparecchiature non confermate.",
        "EQUIPMENT_DATA_NO_COMPLETED": "Hai inserito informazioni incomplete per un nuovo veicolo.",
        "EQUIPMENT_NOT_EXIST_OR_DISABLED_ERROR": "Il tipo di attrezzatura selezionato non esiste o è disabilitato",
        "NO_EQUIPMENT": "Nessuna attrezzatura",
        "THE_ACCESS_RECORD_WAS_MODIFY_AT_THE_DATE": "La data di ingresso è stata modificata il giorno",
        "THE_EXIT_RECORD_WAS_MODIFY_AT_THE_DATE": "La data di uscita è stata modificata il giorno",
        "VIEW_DUE_DOC": "Visualizza la documentazione prevista",
        "DUE_DOC_OF": "Documentazione dovuta da",
        "DUE_DOC_OF_THE_RESOURCE": "Documentazione dovuta della risorsa",
        "CANT_ADD_VEH_WITH_THE_SAME_PATENT": "Non è possibile aggiungere il veicolo perché ne esiste già uno con la stessa targa.",
        "FILTER_MORE_FOR_DOWNLOAD": "Filtrare più per scaricare il report",
        "CANNOT_CREATE_THE": `Non può essere creato`,
        "CANNOT_CREATE": `Non può essere creato`,
        "BECAUSE_EXISTING_RESOURCES_IN_THE": "perché le risorse inserite esistono",
        "BECAUSE_EXISTING_RESOURCES_IN": "perché ci sono risorse inserite in",
        "WHITOUT": "Senza",
        "CANNOT_ENABLE_THE": `Non è possibile abilitare`,
        "CANNOT_ENABLE": `Non è possibile abilitare`,
        "SHOW_CONTRACTS_DETAILS": `Visualizza i dettagli del contratto`,
        "CONTRACTS_DETAILS": `Dettagli del contratto`,
        "EMP_HAS_NOT_CONTRACTS_ASSIGNED": `Il dipendente non è assegnato ad alcun contratto`,
        "VEH_HAS_NOT_CONTRACTS_ASSIGNED": `Il veicolo non è assegnato ad alcun contratto`,
        "INVALID_DATE_MODIFICATION": "Non è possibile modificare la data poiché genererebbe un conflitto con altri movimenti esistenti.",
        "PRIVACY_POLICY": "Informativa sulla privacy",
        "ENTRIES": "Entrate",
        "AREA_SELECT": "Seleziona un'area",
        "MANDATORY_AREA_SELECT": "È necessario specificare l'area e l'opzione 'Accesso gratuito' non sarà disponibile.",
        "EDITED_BY": "Modificato da",
        "REASON": "Motivo",
        "DATE_SINCE_CANT_BE_MORE_THAN_UNTIL_DATE": "La data di inizio non può essere maggiore a la data fino",
        "DATE_RANGE_CANT_BE_MORE_THAN_ONE_YEAR": "L'intervallo di date non può essere maggiore di 1 anno",
        "DATE_RANGE_CANT_BE_FUTURE": "L'intervallo di date non può essere futuro",
        "CONSIDER_CONTRACTS_FOR_RESOURCE_APTITUDE":"Considerare contratos per definire la capacità della risorsa",
        "CONTRACTS_FOR_RESOURCE_APTITUDE_DESC":"Abilitando questa opzione, l'applicazione di ingresso prenderà in considerazione lo stato di tutti i contratti della risorsa per definire se è idonea o non idonea all'accesso.",
        "DUE_DOC_CONTRACTS": "Documentazione dovuta di contrati",
        "CONTRACTS_CONSIDERED_FOR_ENTRY": "Lo stato dei contratti è considerato per l'ingresso.",
        "CONTRACTS_NOT_CONSIDERED_FOR_ENTRY": "Lo stato dei contratti non è considerato per l'ingresso.",
        "CONTRACTS_CONT_STATUS_CONSIDERED_ENTRY_EMP": "Lo stato dei contratti del contraente è considerato per l'ingresso, anche senza assegnazione al dipendente.",
        "CONTRACTS_CONT_STATUS_CONSIDERED_ENTRY_VEH": "Lo stato dei contratti del contraente è considerato per l'ingresso, anche senza assegnazione al veicolo.",
        "CONTRACT_DATE_VALIDITY_TOOLTIP": "La data corrisponde alla validità del contratto",
        "CONTRACT_DATE_RESOURCE_ASSIGNMENT_TOOLTIP": "La data corrisponde all'assegnazione della risorsa al contratto",
    }
}